import Service from 'core/service'
import type { ConfigApplicationModel } from '../store/types'
import type { IApplicationParams } from 'interfaces'

export class ApplicationService extends Service {
  getListApplications(params: any): Promise<ApplicationModel[]> {
    return this.get('/applications', params)
  }
  createApplication(params: any): Promise<ApplicationModel> {
    return this.post('/applications', params)
  }
  updateApplication(params: IApplicationParams): Promise<ApplicationModel> {
    return this.put(`/applications/${params.id}/${params.divisionId}`, params)
  }
  deleteApplication(params: IApplicationParams): Promise<void | null> {
    return this.delete(`/applications/${params.id}/${params.divisionId}`)
  }
  getApplication(params: IApplicationParams): Promise<ApplicationModel> {
    return this.get(`/applications/${params.id}/${params.divisionId}`)
  }
  getConfigApplication(params: IApplicationParams): Promise<ConfigApplicationModel> {
    return this.get(`/applications/${params.id}/${params.divisionId}/config`)
  }
  createConfigApplication(params: IApplicationParams): Promise<ConfigApplicationModel> {
    return this.post(`/applications/${params.id}/${params.divisionId}/config`, params)
  }
  updateConfigApplication(params: IApplicationParams): Promise<ConfigApplicationModel> {
    return this.put(`/applications/${params.id}/${params.divisionId}/config`, params)
  }
  checkApplicationIsUsed(params: IApplicationParams) {
    return this.get(`/applications/${params.id}/${params.divisionId}/is-used`, params)
  }
  getApplicationLogsInWeek(params: any) {
    return this.get('/applications/logsInWeek', params)
  }
}
